<template>
	<div class="card mt-4">
        <div class="card-header">
	    	<div class="d-flex justify-content-between container-fluid">
	            <div class="text-muted fs-19">
	            	<strong>Total por Categoria</strong>
	            </div>
                <bsh-dropdown-nav
				  	id="despesaCategNav"
				  	:tabs="tabs"
				  	:ativo="0"
				  	@navChanged="changePeriod">
				</bsh-dropdown-nav>
		    </div>
	    </div>
	    <div class="card-body">
	    	<table
                class="table table-bordered table-striped"
                style="overflow-x:auto;">
                <thead>
                    <tr>
                        <th class="th-sm">Categoria</th>
                        <th class="th-sm">Total</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="dado in dados" v-if="dados.length > 0">
                        <td v-if="dado.nome">{{ dado.nome }}</td>
                        <td v-else>Sem Categoria</td>
                        <td>{{ parseFloat(dado.total).toFixed(2) }}</td>
                    </tr>
                    <tr v-else>
                        <td colspan="2">
                            Nenhum resultado encontrado.
                        </td>
                    </tr>
                </tbody>
            </table>
	    </div>
	</div>
</template>

<script>
	export default {
        props: ['date'],
        data(){
            return {
                dados: [],
                tabs: [
		            {
		              	label: 'Mês',
		              	field: 'mes'
		            },
		            {
		            	label: 'Ano',
		              	field: 'ano',
		            },
				],
                period: 'mes'
            }
        },
        created(){
            this.getDados()
        },
		methods: {
			getDados(){
				axios.get(this.$url+'/api/adm/despesas/data/categoria/'+this.date+'?period='+this.period)
	            .then(response => {
	            	this.dados = response.data
	            })
	            .catch(error => {
	            	console.log(error)
	            });
			},
            changePeriod(period){
                this.period = period;
                this.getDados()
            }
		},
	}
</script>
